// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-navigation[data-v-77b9262c]{position:absolute;z-index:10;width:100%;background-color:#ffffff;padding:0.5rem;box-shadow:0 0 8px rgba(0,0,0,0.2);border-bottom:1px solid #eee}.page-navigation .page-button[data-v-77b9262c]{min-width:4rem}.page-navigation-enter-active[data-v-77b9262c]{-webkit-animation:fadeInDown .2s;animation:fadeInDown .2s}.page-navigation-leave-active[data-v-77b9262c]{-webkit-animation:fadeOutUp .2s;animation:fadeOutUp .2s}\n", ""]);
// Exports
module.exports = exports;
